import { EnvConfig } from '../types';

const testConfig: EnvConfig = {
  // SENTRY
  SENTRY_ENV: 'test',

  DISABLED_FEATURES: {
    panorama: true,
  },
};

export default testConfig;
